import { useQuery, useQueryClient } from "@tanstack/react-query";
import endOfMonth from "date-fns/endOfMonth";
import { useState } from "react";
import { getParticipantActiveDays } from "../../services";

const ENDPOINT_URL = "/api/assessments/participant-lesson/active-dates";

export const useParticipantActivity = (date?: Date) => {
  const [isQueryEnabled, setIsQueryEnabled] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(
    endOfMonth(date || new Date())
  );

  const query = useQuery({
    queryKey: [ENDPOINT_URL, selectedMonth],
    queryFn: () => getParticipantActiveDays(selectedMonth),
    enabled: isQueryEnabled,
  });

  const changeMonth = (date: Date) => {
    setSelectedMonth(endOfMonth(date));
    if (!isQueryEnabled) setIsQueryEnabled(true);
  };

  return {
    ...query,
    selectedMonth,
    setSelectedMonth: changeMonth,
  };
};

export const useUpdateParticipantActivity = () => {
  const queryClient = useQueryClient();
  const participantActivityQueryKey = [ENDPOINT_URL, endOfMonth(new Date())];

  const addTodayActivity = () => {
    const cache: string[] = queryClient.getQueryData(
      participantActivityQueryKey
    );

    if (!cache) return;

    cache.push(new Date().toISOString());
    queryClient.setQueryData(participantActivityQueryKey, cache);
  };

  return {
    addTodayActivity,
  };
};
